/** Feature Section — VistoeraTASK-00262. Only capabilities that already
 * exist and ship in the Canvas node catalog get listed here as product
 * copy (see `backend/app/domain/canvas_node_catalog_seed.py`) — retired
 * the old single-function 商品图片处理 copy that predates the Canvas/SaaS
 * pivot. Real availability is verified separately at integration time. */
const FEATURES = [
  { icon: '⚡', title: 'Canvas 自由编排', desc: '在画布上连接创意、剧本、分镜与生成节点，构建你的内容生产流程。' },
  { icon: '🎬', title: '图片 / 视频 / 音频生成', desc: '一站完成图片、视频、语音等素材生成，无需切换多个工具。' },
  { icon: '🔗', title: '流程自动衔接', desc: '修改上游节点后，下游素材根据新的结果重新生成。' },
  { icon: '🏢', title: '素材归属于你的 Workspace', desc: '不同 Workspace 的资产严格隔离，只属于你自己。' },
  { icon: '⬇️', title: '统一资产管理', desc: '图片、视频、音频、文本素材统一管理，随时下载到本地。' },
]

export default function FeatureSection() {
  return (
    <section className="mkt-section" id="features">
      <div className="mkt-container">
        <h2>你的内容生产 Canvas</h2>
        <p className="mkt-section-sub">在同一个画布上编排生成流程，也可以随时手动调整任意一步。</p>
        <div className="mkt-grid-3">
          {FEATURES.map((f) => (
            <div className="mkt-card" key={f.title}>
              <div className="mkt-card-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
